import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import React from 'react';

import overrideStyle from 'lib/overrideStyle';
import LoadingPlaceholder from 'presentation/components/icons/LoadingPlaceholder';
import styles from 'presentation/components/styles/ErrorBanner.css';
import TryAgain from 'presentation/components/icons/TryAgain';

class ErrorBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animateIn: false,
    };

    ErrorBanner.propTypes = {
      animateIn: PropTypes.bool,
      buttonText: PropTypes.string,
      errorMessage: PropTypes.string,
      errorType: PropTypes.string,
      isChatClientConnected: PropTypes.bool.isRequired,
      isChatClientReconnecting: PropTypes.bool.isRequired,
      onClick: PropTypes.func.isRequired,
      shouldShowSvg: PropTypes.bool.isRequired,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    this.setState({ animateIn: this.props.animateIn });
  }

  handleClick() {
    this.props.onClick();
  }

  handleKeyDown(ev) {
    if (ev.keyCode === 13 || ev.keyCode === 32) {
      ev.preventDefault();
      this.handleClick();
    }
  }

  render() {
    return (
      <div className={styles.connectionErrorBannerWrapper}>
        <CSSTransition
          classNames={{
            enter: styles.connectionErrorBannerTransitionEnter,
            enterDone: styles.connectionErrorBannerTransitionEnterDone,
            exit: styles.connectionErrorBannerTransitionExit,
            exitDone: styles.connectionErrorBannerTransitionExitDone,
            exitActive: styles.connectionErrorBannerTransitionExitActive,
          }}
          in={this.state.animateIn}
          timeout={300}
          unmountOnExit
        >
          <div
            className={styles.connectionErrorBanner}
            tabIndex="0"
            role="button"
            onClick={this.handleClick}
            onKeyDown={this.handleKeyDown}
          >
            <div className={styles.connectionErrorMessage}>{this.props.errorMessage}</div>
            <div className={styles.connectionErrorTryAgainWrapper}>
              {renderBannerContents(
                this.props.isChatClientReconnecting,
                this.props.shouldShowSvg,
                this.props.buttonText
              )}
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

function renderBannerContents(isChatClientReconnecting, shouldShowSvg, buttonText) {
  if (isChatClientReconnecting) {
    return <LoadingPlaceholder isErrorBanner color="#FFFFFF" size="10px" />;
  } else {
    return (
      <React.Fragment>
        {shouldShowSvg ? <TryAgain buttonText={buttonText} /> : <StyledDismiss>{buttonText}</StyledDismiss>}
      </React.Fragment>
    );
  }
}

const StyledDismiss = overrideStyle('div')`
  border: 1px solid white;
  border-radius: 25px;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  flex: 1 0 auto;
  flex-direction: row;
  font-size: 14px;
  padding: 8px 12px 8px 12px;

  &:active {
    background-color: #1D1D24;
  }
  &:hover {
    background-color: #2A2A31;
  }
`;
export default ErrorBanner;
